import React, {useCallback, useEffect, useMemo} from 'react';
import Wavesurfer from "react-wavesurfer";
import WavesurferPlayer, { useWavesurfer } from "@wavesurfer/react";

const PlayerWave = ({
  audioFile,
  onPosChange,
  playing,
  progressColor,
  onReady
}) => {
  const containerRef = React.useRef(null);

  const { wavesurfer, isReady, isPlaying, currentTime } = useWavesurfer({
    container: containerRef,
    height: 70,
    waveColor: "rgba(0, 0, 0, 0.3)",
    progressColor,
    url: audioFile
  });

  const onPlayPause = useCallback(() => {
    wavesurfer && wavesurfer.playPause();
  }, [wavesurfer]);

  useEffect(() => {
    if (wavesurfer) {
      wavesurfer.on('ready', onReady);
      wavesurfer.on('timeupdate', onPosChange);

      if (playing) {
        wavesurfer.play();
      } else {
        wavesurfer.pause();
      }
    }
  }, [wavesurfer, playing]);

  return <div ref={containerRef} />;
  // <WavesurferPlayer
  //   height={70}
  //     url={audioFile}
  //     cursorWidth={0}
  //     barWidth={1}
  //     waveColor={"rgba(0, 0, 0, 0.3)"}
  //     progressColor={"#000"}
  //     onAudioprocess={onPosChange}
  //     // playing={playing}
  //     // options={{
  //     //   cursorWidth: 0,
  //     //   barWidth: 1,
  //     //   height: 70,
  //     //   waveColor: "rgba(0, 0, 0, 0.3)",
  //     //   progressColor: "#000"
  //     // }}
  //     onReady={handleReady}
  //   />
};

export default PlayerWave;
